import axios from 'axios'
const baseURL = process.env.VUE_APP_API_URL_POPINFO

const apiRequestPopinfo = axios.create({
  baseURL
})

apiRequestPopinfo.interceptors.response.use(
  res => {
    return res
  },
  err => {
    return Promise.reject(err)
  }
)

export default apiRequestPopinfo
